import _ from 'underscore';
import React, { useState } from 'react';
import {
  domChildren as domChildrenProps,
} from '@bingads-webui-campaign-react/props-mca';

/**
 * Used to store global event callback context.
 */
export const GlobalEventCallbackContext = React.createContext({
  signoutCallback: null,
  setSignoutCallback: _.noop,
});

export function GlobalEventCallbackContextProvider(props) {
  const { children } = props;
  const [signoutCallback, setSignoutCallback] = useState(null);

  return (
    <GlobalEventCallbackContext.Provider value={{
      signoutCallback,
      setSignoutCallback,
    }}
    >
      {children}
    </GlobalEventCallbackContext.Provider>
  );
}

GlobalEventCallbackContextProvider.propTypes = {
  children: domChildrenProps.isRequired,
};
